<header class="topbar">
  <nav
    [ngClass]="isAdminRoute ? 'top-navbar-admin' : 'top-navbar-user'"
    class="navbar top-navbar navbar-expand-md navbar-light"
  >
  <ng-container *ngIf="!configuration.showCustomBranding; else customHeader">
    <div [ngClass]="(isAdminRoute) ? 'header-user' : 'header-admin'" class="navbar-header col-2 pl-0 pr-0">
      <a class="d-flex justify-content-around align-items-center display-block" [routerLink]="['/user/survey-list']">
              <img class="logo" src="../../../assets/images/LOGO_KPMG.png"
                alt="KPMG" />
      </a>
    </div>
  </ng-container>
  <ng-template #customHeader>
          <div class="custom-navbar-header col-2 pl-0 pr-0">
            <a class="navbar-brand" [routerLink]="['/']">
              <img class="custom-app-logo" [src]="configuration.customLogo"
                [alt]="configuration.customCompanyName" />
            </a>
          </div>
  </ng-template>
    <div *ngIf="user" [ngClass]="isAdminRoute ? 'navbar-collapse-admin' : 'navbar-collapse-user'" class="navbar-collapse pr-4">
      <ul class="navbar-brand">
        <li>Feedback Tool</li>
      </ul>
      <ul [ngClass]="isAdminRoute ? 'd-none' : 'inline-flex'" class="navbar-nav">
        <li *ngIf="!isOriginalIdentity" class="btn-group" #dropdown="bs-dropdown" dropdown [autoClose]="true">
          <ul>
            <li
              (click)="toggleNotificationBar($event)"
              id="button-basic"
              aria-controls="dropdown-notifications"
              class="ic-notifications dropdown-toggle"
            >
              <i class="mdi mdi-bell"></i>
              <div class="letter-anime">
                <div class="circle" [class.circle-user]="hasUnviwedNotifications"></div>
                <span [class.letter-user]="hasUnviwedNotifications"></span>
              </div>
            </li>
          </ul>
          <ul
            (click)="$event.stopPropagation()"
            (clickOutside)="onClickedOutside($event)"
            id="dropdown-notifications"
            *dropdownMenu
            class="dropdown-menu"
            role="menu"
            aria-labelledby="button-basic"
          >
            <li class="text-right">
              <div class="row">
                <div class="col-12">
                  <span (click)="deleteNotificationAll()" class="clear-all">
                    {{ 'lang.notification.clearAll' | translate }}
                  </span>
                </div>
              </div>
            </li>
            <!-- [bottomOffset]="20" [topOffset]="20 -->
            <li slimScroll width="auto" height="600px" size="3px" detect-scroll (onScroll)="handleScroll($event)">
              <span
                *ngFor="let notification of notifications"
                [@flyInOut]="animationState"
                class="list-notifications"
                [class.notification-unread]="!notification.viewed"
              >
                <span class="caption">
                  <i [ngClass]="showNotificationType(notification.body.messageType)"></i>
                  <span>{{ formatDate(notification.createdDate) }}</span>
                </span>
                <span (click)="goToNotificationSourcePage(notification, notification.body.messageType)">
                  <span
                    *ngIf="notification.body.messageType === notificationTypes.creationRespondentListNotificationType"
                    class="essence-notifications"
                  >
                    {{ 'lang.notification.create.makeRespondentList' | translate }}
                    <span>{{ getLocateName(notification.body.processName) }}</span>
                  </span>
                  <span
                    *ngIf="notification.body.messageType === notificationTypes.anonymCommonCommentNotificationType"
                    class="essence-notifications"
                  >
                    {{ 'lang.notification.comment.anonymFeedbackRecieved' | translate }}
                    <span class="text-comment">
                      {{ notification.body.notificationBody }}
                    </span>
                  </span>
                  <span
                    *ngIf="
                      notification.body.messageType ===
                      notificationTypes.anonymCommentPerformanceManagerNotificationType
                    "
                    class="essence-notifications"
                  >
                    {{ 'lang.notification.comment.teammateAnonymFeedbackRecieved' | translate }}
                    <span class="name-user">{{ notification.body.receiverName }}</span>
                  </span>
                  <span
                    *ngIf="
                      notification.body.messageType ===
                        notificationTypes.confirmationRespondentsBusinessUnitAdministratorNotificationType ||
                      notification.body.messageType ==
                        notificationTypes.confirmationRespondentsPerformanceManagerNotificationType
                    "
                    class="essence-notifications"
                  >
                    {{ 'lang.notification.confirm.confirmRespondent' | translate }}
                    <span class="name-user">{{ notification.body.employeeName }}</span>
                    {{ 'lang.notification.confirm.ofSurvey' | translate }} '<span>{{
                      getLocateName(notification.body.processName)
                    }}</span
                    >'.
                  </span>
                  <span
                    *ngIf="
                      notification.body.messageType === notificationTypes.commonCommentNotificationType ||
                      notification.body.messageType == notificationTypes.commentPerformanceManagerNotificationType
                    "
                    class="essence-notifications"
                  >
                    <span *ngIf="!!notification.type">
                      <span class="name-user"> {{ notification.body.senderName }} </span>
                      {{ 'lang.notification.comment.teammateFeedbackRecieved' | translate }}
                      <span class="name-user"> {{ notification.body.receiverName }} </span>
                      <span class="text-comment">
                        {{ notification.body.notificationBody }}
                      </span>
                    </span>
                    <span *ngIf="!notification.type">
                      <span class="name-user">{{ notification.body.senderName }}</span
                      >{{ 'lang.notification.comment.feedbackRecieved' | translate }}
                      <span class="text-comment">
                        {{ notification.body.notificationBody }}
                      </span>
                    </span>
                  </span>
                  <span
                    *ngIf="
                      notification.body.messageType === notificationTypes.processParticipationAssingnedNotificationType
                    "
                    class="essence-notifications"
                  >
                    {{ 'lang.notification.review.completeSurvey' | translate }}
                    <span class="name-user">{{ notification.body.senderName }}</span>
                    <span class="text-comment">
                      {{ getLocateName(notification.body.processName) }}
                    </span>
                  </span>
                  <span
                    (click)="deleteNotification(notification, $event)"
                    class="mdi mdi-close btn-delete-message"
                  ></span>
                </span>
              </span>
            </li>
          </ul>
        </li>
        <li class="nav-item small-margin-right">
          <a href="mailto:hr@codebridge.tech" class="contact-us">
            {{ 'lang.links.contact' | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a [href]="'lang.links.help' | translate" target="_blank">
            <i class="mdi mdi-help-circle-outline"></i>
          </a>
        </li>
        <li *ngIf="avaliableLanguages?.length > 1" class="nav-item">
          <span
            [id]="lang.name"
            *ngFor="let lang of avaliableLanguages"
            (click)="setLanguage(lang.code)"
            [ngClass]="{ 'langs-active': getIsChosenLanguage(lang.code) }"
          >
            {{ lang.name }}
          </span>
        </li>
      </ul>
      <ul [ngClass]="!isAdminRoute ? 'd-none' : 'inline-flex'" class="navbar-nav">
        <li (click)="$event.stopPropagation()" class="btn-group" dropdown>
          <label class="log-as dropdown-toggle" id="log-as" dropdownToggle aria-controls="dropdown-basic">
            <i class="mdi mdi-power"></i>
            <span>Log as</span>
          </label>
          <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="log-as">
            <li>Log in as another employee</li>
            <li class="list-builder">
              <span *ngIf="!isLeaverMode" class="caption"> Employee / GPID </span>
              <span *ngIf="isLeaverMode" class="caption"> GPID </span>
              <span class="for-dropdown">
                <ngx-select
                  [allowClear]="true"
                  [items]="employeeOptions"
                  optionValueField="id"
                  optionTextField="name"
                  (remove)="clearEmployeeOptions()"
                  (select)="selectedEmployeeOption($event)"
                  (typed)="typedEmployeeOptions($event)"
                  placeholder=""
                >
                </ngx-select>
              </span>
              <div class="col-12 mt-2 p-0 isLeaver-checkbox">
                <input type="checkbox" id="checkbox0" (change)="clearEmployeeSelection()" [(ngModel)]="isLeaverMode" />
                <label for="checkbox0">Leaver</label>
              </div>
            </li>
            <li class="m-b-20 m-t-20 list-builder text-right">
              <span class="btn-cancel" (click)="cancelImpersonateSelection()">Cancel</span>
              <span class="btn-confirm" (click)="impersonateEmployee()">Confirm</span>
            </li>
            <li class="m-t-20 list-builder text-center">
              <span class="btn-return-page" (click)="cancelImpersonation()"> Return to your page </span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</header>
